import { render } from "./ClientTabs.vue?vue&type=template&id=de262928&scoped=true"
import script from "./ClientTabs.vue?vue&type=script&lang=js"
export * from "./ClientTabs.vue?vue&type=script&lang=js"

import "./ClientTabs.vue?vue&type=style&index=0&id=de262928&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de262928"]])

export default __exports__